import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Skip /auth/me on public magic-link routes so we don't spam 401s on
    // pages that never need a session (renter portal, apply, lease sign).
    const path = window.location.pathname || "";
    const publicPrefixes = ["/rent/", "/rent-lease/", "/rent-apply/", "/report/", "/sub/",
                             "/cleaner/", "/tradesman/", "/student", "/quotes/approve/"];
    const isPublic = publicPrefixes.some(p => path.startsWith(p));
    if (isPublic || !localStorage.getItem("access_token")) {
      setUser(false); setLoading(false); return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("access_token", data.access_token);
    setUser(data.user);
    window.dispatchEvent(new Event("auth-changed"));
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("access_token", data.access_token);
    setUser(data.user);
    window.dispatchEvent(new Event("auth-changed"));
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.warn("logout API failed (clearing local state anyway)", err); }
    localStorage.removeItem("access_token");
    localStorage.removeItem("impersonate_tenant");
    localStorage.removeItem("impersonate_tenant_name");
    setUser(false);
    window.dispatchEvent(new Event("auth-changed"));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
